import AuthScreenLayout from '../../../components/authScreenLayout/AuthScreenLayout';
import Title from '../../../components/title/Title';

const TermsAndConditions = () => {
  return (
    <>
      <AuthScreenLayout>
        <Title color='white'>Terms and conditions</Title>
      </AuthScreenLayout>
    </>
  );
};

export default TermsAndConditions;
